/* eslint-disable import/no-anonymous-default-export */
import { routerRedux } from "dva/router";
import { Alert } from "../components/Alert.components";

import {
  getRequestForms,
  postRequestForm,
  deleteRequestForm,
  putRequestForm,
  getRequestsByStatus,
  getUserRequestsByStatus,
  getActivities,
  getAllRequests,
  getExportReportAsCsv,
  getExportReportAsPdf
} from "../services/config";

import { storageConfigModel } from "../utils/constant";

const initialState = {
  requestFormsList: [],
  requestFormsTotal: 0,
  createRequestModal: false,
  deleteRequestModal: false,
  changeRequestModal: false,
  exportReportModal: false,
  singleRequestData: {},
  userAggerateRequest: [],
  companyAggerateRequest: [],
  activities: [],
  reportList: [],
  reportListTotal: 0
};

export default {
  namespace: "config",

  state: {
    ...initialState,
  },

  subscriptions: {
    setup({ dispatch }) {
      // eslint-disable-line
      try {
        let config_model = localStorage.getItem(storageConfigModel);
        if (config_model) {
          let data = JSON.parse(config_model);
          dispatch({
            type: "save",
            payload: data,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
  },

  effects: {
    *fetchAllRequestForms({ payload }, { call, put }) {
      const { raw, success, message } = yield call(getRequestForms, payload);
      if (success) {
        const list = raw?.requestForms;
        const total = raw?.totalItems;
        yield put({
          type: "save",
          payload: { requestFormsList: list, requestFormsTotal: total },
        });
      } else {
        Alert.error(message);
      }
    },
    *fetchAllRequests({ payload }, { call, put }) {
      const { raw, success, message } = yield call(getAllRequests, payload);
      console.log(raw)
      if (success) {
        const list = raw?.requests;
        const total = raw?.totalItems;
        yield put({
          type: "save",
          payload: { requestFormsList: list, requestFormsTotal: total },
        });
      } else {
        Alert.error(message);
      }
    },

    *fetchAllReports({ payload }, { call, put }) {
      const { raw, success, message } = yield call(getAllRequests, payload);
      if (success) {
        const list = raw?.requests;
        const total = raw?.totalItems;
        yield put({
          type: "save",
          payload: { reportList: list, reportListTotal: total },
          
        });
      } else {
        Alert.error(message);
      }
    },
    *fetchAllActivities({ payload }, { call, put }) {
      const { raw, success, message } = yield call(getActivities, payload);
      console.log(raw)
      if (success) {
        const list = raw?.activities;
        yield put({
          type: "save",
          payload: { activities: list, },
        });
      } else {
        Alert.error(message);
      }
    },
    
    *fetchCompanyRequestByStatus({ payload }, { call, put }) {
      const { raw, success, message } = yield call(
        getRequestsByStatus,
        payload
      );
      console.log(raw);
      if (success) {
        const list = raw?.results;
        yield put({
          type: "save",
          payload: { companyAggerateRequest: list },
        });
      } else {
        Alert.error(message);
      }
    },
    *fetchUserRequestByStatus({ payload }, { call, put }) {
      const { raw, success, message } = yield call(
        getUserRequestsByStatus,
        payload
      );
      console.log(raw);
      if (success) {
        const list = raw?.results;
        yield put({
          type: "save",
          payload: { userAggerateRequest: list },
        });
      } else {
        Alert.error(message);
      }
    },
    *getSingleForm({ payload }, { call, put }) {
      yield put({
        type: "save",
        payload: { singleRequestData: payload },
      });
    },
    *createRequestForm({ payload }, { call, put }) {
      const { raw, success, message } = yield call(postRequestForm, payload);
      if (success) {
        Alert.success("Request form has been successfully created.");
        yield put(routerRedux.push("/requests"));
      } else {
        Alert.error(message);
      }
    },
    *deleteRequestForm({ payload }, { call, put, select }) {
      const { raw, success, message } = yield call(deleteRequestForm, payload);
      if (success) {
        const data = raw?.deletedRequestForm;
        const oldList = yield select(({ config }) => config.requestFormsList);
        const newList = oldList.filter((item) => item._id !== data._id);
        yield put({
          type: "save",
          payload: { deleteRequestModal: false, requestFormsList: newList },
        });
        Alert.success("Request form has been successfully deleted.");
      } else {
        Alert.error(message);
      }
    },
    *getExportReportsCsv({ payload }, { call, put, select }) {
      const { raw, success, message } = yield call(getExportReportAsCsv, payload);
      if (success) {
        console.log(raw);
        yield put({
          type: "save",
          payload: { exportReportModal: false },
        });
        Alert.success("Please, check your mail, reports has been successfully exported.");
      } else {
        Alert.error(message);
      }
    },
    *getExportReportsPdf({ payload }, { call, put, select }) {
      const { raw, success, message } = yield call(getExportReportAsPdf, payload);
      if (success) {
        console.log(raw);
        yield put({
          type: "save",
          payload: { exportReportModal: false },
        });
        Alert.success("Please, check your mail, reports has been successfully exported.");
      } else {
        Alert.error(message);
      }
    },
    *changeRequestForm({ payload }, { call, put, select }) {
      const { raw, success, message } = yield call(putRequestForm, payload);
      if (success) {
        const data = raw?.updatedReqForm;
        const oldList = yield select(({ config }) => config.requestFormsList);
        const prevList = oldList.filter(req => req?._id !== data?._id)
        const newList = [data, ...prevList];
        yield put({
          type: "save",
          payload: { changeRequestModal: false, requestFormsList: newList },
        });
        Alert.success("Request form status has been successfully edited.");
      } else {
        Alert.error(message);
      }
    },
    *editRequestForm({ payload }, { call, put, select }) {
      const { raw, success, message } = yield call(putRequestForm, payload);
      if (success) {
        Alert.success("Request form has been successfully edited.");
        yield put(routerRedux.push("/requests"));
      } else {
        Alert.error(message);
      }
    },
  },

  reducers: {
    save(state, action) {
      const newPayload = {
        ...state,
        ...action.payload,
      };

      try {
        let data = JSON.stringify(newPayload);
        localStorage.setItem(storageConfigModel, data);
      } catch (err) {
        console.log(err);
      }

      return newPayload;
    },
  },
};
